import ParkingAreaAddPriceRuleSetPage from "./parkingAreaAddPriceRuleSet";

export default ParkingAreaAddPriceRuleSetPage;